
import Vue from 'vue'
import axios from 'axios'
import router from '../router'

import { Message } from 'element-ui'

//测试环境
// Vue.prototype.TextUrl = 'https://ydt-api.amcmj.com/';
// axios.defaults.baseURL = 'https://ydt-api.amcmj.com/';

//正式环境
Vue.prototype.TextUrl = 'https://api.ydtaj.com/';
axios.defaults.baseURL = 'https://api.ydtaj.com/';

//请求超时时间
axios.defaults.timeout = 30000; //30s

// 请求拦截器

axios.interceptors.request.use(
    config => {
        // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
        // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
        const token = JSON.parse(localStorage.getItem('token'));
        config.headers = {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'application/json; charset=UTF-8',
        }
        token && (config.headers.token = token)
        return config
    },
    error => {
        return Promise.error(error)
    })

// 响应拦截器
axios.interceptors.response.use(
    response => {
        if (response.data.code == 0 && response.data.msg == 1000) {
            Message({
                message: '登录超时,请重新登录!',
                type: 'error'
            });
            localStorage.removeItem('memberInfo');
            localStorage.removeItem('token');
            let urlArr = location.href.split('\/');
            router.push({
                path: '/login',
                query:{
                    redirect: '/' + urlArr[urlArr.length-1]
                }
            })
            return Promise.reject(response)
        }
        if (response.status == 200) {
            return Promise.resolve(response)
        } else {
            return Promise.reject(response)
        }
    },
    // 服务器状态码不是200的情况
    error => {
        if (error.response.status) {
            switch (err.response.status) {
                case 400:
                    Message({
                        message: '错误请求!',
                        type: 'error'
                    });
                    break;
                case 401:
                    Message({
                        message: '未授权，请重新登录!',
                        type: 'error'
                    });
                    break;
                case 403:
                    Message({
                        message: '拒绝访问!',
                        type: 'error'
                    });
                    break;
                case 404:
                    Message({
                        message: '请求错误,未找到该资源!',
                        type: 'error'
                    });
                    break;
                case 405:
                    Message({
                        message: '请求方法未允许!',
                        type: 'error'
                    });
                    break;
                case 408:
                    Message({
                        message: '请求超时!',
                        type: 'error'
                    });
                    break;
                case 500:
                    Message({
                        message: '服务器端出错!',
                        type: 'error'
                    });
                    break;
                case 501:
                    Message({
                        message: '网络未实现!',
                        type: 'error'
                    });
                    break;
                case 502:
                    Message({
                        message: '网络错误!',
                        type: 'error'
                    });
                    break;
                case 503:
                    Message({
                        message: '服务不可用!',
                        type: 'error'
                    });
                    break;
                case 504:
                    Message({
                        message: '网络超时!',
                        type: 'error'
                    });
                    break;
                case 505:
                    Message({
                        message: 'http版本不支持该请求!',
                        type: 'error'
                    });
                    break;
                default:
                    console.log(`连接错误${err.response.status}`)
            }
            return Promise.reject(error.response)
        }
    }
)

const CancelToken = axios.CancelToken;
Vue.$httpReqList = [];

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
    return new Promise((resolve, reject) => {
        let obj = {
            cancelToken: new CancelToken(function executor(c) {
                Vue.$httpReqList.push(c)
            })
        }
        axios.get(url, {
            params: params
        }, obj).then(res => {
            resolve(res.data)
        }).catch(err => {
            reject(err.data)
        })
    })
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {
    return new Promise((resolve, reject) => {
        let obj = {
            cancelToken: new CancelToken(function executor(c) {
                Vue.$httpReqList.push(c)
            })
        }
        axios.post(url, params, obj)
            .then(res => {
                resolve(res.data)
            })
            .catch(err => {
                reject(err.data)
            })
    })
}



// WEBPACK FOOTER //
// ./src/apis/axios.js